export const BP3D_EVENT_CONFIG_CHANGED = 'bp3dEvent.config_changed';
export const BP3D_EVENT_LINKED_ITEMS_CHANGED = 'bp3dEvent.linked_item_changed';
export const BP3D_EVENT_HIGHLIGHT_CHANGED = 'bp3dEvent.highlight_changed';
